(() => {
  const collectionUrl = '/collections';
  const tiktokUrl = 'https://www.tiktok.com/@thefigurevault7';

  document.querySelectorAll('main a[href*="tiktok.com"]').forEach((link) => {
    link.href = tiktokUrl;
    if (link.textContent.trim().toLowerCase().startsWith('follow')) {
      link.textContent = 'Follow @thefigurevault7';
    }
  });

  document.querySelectorAll('main h1, main h2, main h3').forEach((heading) => {
    const title = heading.textContent.trim().toLowerCase();
    if (title === 'latest articles') {
      const section = heading.closest('section');
      const description = Array.from(section?.querySelectorAll('p') || [])
        .find((paragraph) => paragraph.textContent.trim().toLowerCase().startsWith('add on'));
      if (description) {
        description.textContent = 'Expert guides for choosing, fitting, and posing custom capes and accessories for your collectible figures.';
      }
    }
    if (title === 'only 24.50') {
      heading.textContent = 'From $24.50';
    }
  });

  document.querySelectorAll('main a').forEach((link) => {
    if (link.textContent.trim().toLowerCase() === 'buy' && link.pathname === '/') {
      link.href = collectionUrl;
      link.textContent = 'Shop All';
    }
  });

  document.querySelectorAll('a.dropdown-toggle').forEach((link) => {
    if (link.textContent.trim().toLowerCase() !== 'products') return;
    const menu = link.parentElement?.querySelector('.dropdown-menu');
    if (!menu) return;
    link.href = collectionUrl;
    link.classList.remove('dropdown-toggle');
    link.removeAttribute('data-bs-toggle');
    link.removeAttribute('role');
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'nav-link dropdown-toggle';
    toggle.setAttribute('data-bs-toggle', 'dropdown');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open product categories');
    link.after(toggle);
  });

  document.querySelectorAll('#offcanvas-menu .nav-level-0 > .nav-item > a').forEach((link) => {
    if (link.textContent.trim().toLowerCase() !== 'products') return;
    const target = link.getAttribute('href');
    const controls = link.getAttribute('aria-controls');
    if (!target || !controls || !document.getElementById(controls)) return;
    link.href = collectionUrl;
    link.removeAttribute('data-bs-toggle');
    link.removeAttribute('role');
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'nav-link dropdown-toggle';
    toggle.setAttribute('data-bs-toggle', 'collapse');
    toggle.setAttribute('data-bs-target', target);
    toggle.setAttribute('aria-controls', controls);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open product categories');
    link.after(toggle);
  });
})();